import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  permissions: "/permissions",
};

export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.permissions, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
